export const formatToTime = (durationInSeconds) => {
  const h = Math.floor(durationInSeconds / 3600);
  const m = Math.floor((durationInSeconds % 3600) / 60);
  const s = Math.floor(durationInSeconds % 60);

  const parts = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}m`);
  if (s > 0 || parts.length === 0) parts.push(`${s}s`);

  return parts.join(' ');
};
